/**
 * @generated SignedSource<<fde90c3b472887aafa408f3d64872c2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateHeaderSectionRelayFragment$data = {
  readonly name: string | null | undefined;
  readonly oneLinerHeadline: string | null | undefined;
  readonly pluginModuleKey: string;
  readonly " $fragmentSpreads": FragmentRefs<"templateAuthorRelayFragment">;
  readonly " $fragmentType": "templateHeaderSectionRelayFragment";
};
export type templateHeaderSectionRelayFragment$key = {
  readonly " $data"?: templateHeaderSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateHeaderSectionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateHeaderSectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneLinerHeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluginModuleKey",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateAuthorRelayFragment"
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "91eb2df9d084ed2c556436f9b6a32106";

export default node;
